import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ModalType } from "@/app/types/modal";

interface ModalState {
  modals: ModalType[];
}

const initialState: ModalState = { modals: [] };

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    append: (state, action: PayloadAction<ModalType>) => {
      state.modals.push(action.payload);
    },
    destroy: (state, action: PayloadAction<string>) => {
      state.modals = state.modals.filter((m) => m.name !== action.payload);
    },
    destroyAll: (state) => {
      state.modals = [];
    },
    updateTitle: (state, action: PayloadAction<{ name: string; title: string }>) => {
      const modal = state.modals.find((m) => m.name === action.payload.name);
      if (modal) modal.title = action.payload.title;
    },
  },
});

export const { append, destroy, destroyAll, updateTitle } = modalSlice.actions;
export default modalSlice.reducer;